import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Builder } from '../types/showcase';
interface BuilderLogoGridProps {
  builders: Builder[];
  showNames?: boolean;
}
export function BuilderLogoGrid({
  builders,
  showNames = false
}: BuilderLogoGridProps) {
  return <ul className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-line bg-line sm:grid-cols-3 lg:grid-cols-5" data-id="element-26" data-mp="2avr3ggvfwhs">
      {builders.map(b => {
      const inner = <>
            <span className="flex h-16 w-full items-center justify-center" data-id="element-27" data-mp="uzkz7zgch231">
              <img src={b.logo} alt={`${b.name} logo`} className="max-h-16 max-w-[80%] object-contain" loading="lazy" data-id="element-28" data-mp="v1nm4am7af3j" />
            </span>
            {showNames && <span className="mt-3 flex items-center gap-1 text-center text-sm font-medium text-ink" data-id="element-29" data-mp="l8yn4f7u6tp3">
                {b.name}
                {b.url && <ArrowUpRightIcon className="h-3.5 w-3.5 text-muted" aria-hidden="true" data-id="element-30" data-mp="1dy5khavk1d8r" />}
              </span>}
          </>;
      return <li key={b.name} className="bg-white" data-id="element-31" data-mp="w5papfrfm9to">
            {b.url ? <a href={b.url} target="_blank" rel="noreferrer" aria-label={`${b.name} website`} className="flex h-full min-h-[128px] flex-col items-center justify-center px-4 py-5 transition-colors duration-150 hover:bg-canvas focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-navy" data-id="element-32" data-mp="1138sgpnc94qd">
                {inner}
              </a> : <div className="flex h-full min-h-[128px] flex-col items-center justify-center px-4 py-5" data-id="element-33" data-mp="3h1kr6vqmw9s">{inner}</div>}
          </li>;
    })}
    </ul>;
}